import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class Page extends Model {
  idPage: number;
  idUserDomain?: number;
  name?: string;
  description: string; // page's title
  longDescription?: string;
  type: string;
  status: string;
  creationDate: string;
  modifiedDate: string;
  editorHtml?: string;
  previewHtml?: string;
  publishHtml?: string;
  piWikSiteId?: number;
  publishHtmlTitle?: string;
  publishHtmlAnalyticsCode: string;
}

export class ApiGetPageOptions extends Model {
  pageType: string;
  statuses: string[];
  dateFrom: string;
  dateTo: string;
}

export class Pages extends Paginated {
  data: Array<Page>;
}

export class PublishPageRequest extends Model {
  idPage: number;
  idUserDomain: number;
  name: string; // url resource name
}

export enum PagesType {
  PAGE = 'PAGE',
  SURVEY = 'SURVEY',
  FORM = 'FORM'
}

export enum PagesStatus {
  ONLINE = 'ONLINE',
  DRAFT = 'DRAFT',
  OFFLINE = 'OFFLINE',
  ARCHIVED = 'ARCHIVED',
  PUBLISHING = 'PUBLISHING',
  PUBLISH_ERROR = 'PUBLISH_ERROR'
}

export class EditPage {
  idPage: number;
  idUserDomain?: number;
  descriptionName: string;
  description?: string;
  publishHtmlAnalyticsCode?: string;
  publishHtmlTitle?: string;
  editorHtml?: string;
  previewHtml?: string;
  publishHtml?: string;
}

export class AtlasPageRequest extends Model {
  idPage: number;
  idUserDomain?: number;
  description: string; // page's title
}

export enum PagesStatusHTMLSpanDraw {
  ONLINE = '<span class="badge badge-shared">',
  OFFLINE = '<span class="badge badge-archived">',
  ARCHIVED = '<span class="badge badge-archived">',
  DRAFT = '<span class="badge badge-draft">',
  PUBLISHING = '<span class="badge badge-shared">',
  PUBLISH_ERROR = '<span class="badge badge-error-pubblish">'
}

export class PageStatsVisitsByDay extends Model {
  uniqueVisits: PageStats;
  visits: PageStats;
}

export class PageStats extends Model {
  labels: string[];
  percs: string[];
  values: number[];
  average: string;
  total: number;
}

export class PageStatsClicksByDay extends Model {
  resource: string;
  statistics: PageStats;
  uniqueClicks: PageStats;
  clicks: PageStats;
}

export class PageStatsDeviceAndOs extends Model {
  device: DeviceAndOsStats[];
  'operating-system': DeviceAndOsStats[];
}

export class DeviceAndOsStats extends Model {
  resource: string;
  statistics: PageStats;
}

export class PageUpTimeStats extends Model {
  pageUpTime: UpTimes[];
  totalUpTimeDays: number;
}

export class UpTimes extends Model {
  startDate: string;
  endDate: string;
  numDays: number;
}

export class ExportPageStats extends Model {
  email: string;
}

export class ApiGetFormInteractionsOptions {
  'contacts-filters': {
    'basic-filters': {
      name?: string;
      surname?: string;
      // 'id-group'?: string;
      email?: string;
      phone?: string;
    };
  };
}

export class FormInteraction extends Model {
  _id: string;
  afterDeserialize(input: any) {
    console.log('input', input);
    Object.assign(this, input['_source']);
  }
}

export class FormInteractions extends Paginated {
  data: Array<FormInteraction>;
}
